<template>
<a-row class="container-fluid container-wrap col-sm-12 col-xs-12" style="max-width: 1600px;">
    <a-col :span="1" />
    <a-col class="justify-content-center" :span="22">
        <div style="margin-top: 28px" />
        <div class="card-header pb-0 col-sm-12 d-flex">
            <div class="col-sm-12 col-xs-12">
                <div class="col-sm-12 col-xs-12 justify-content-between titleContainer">
                    <h3 class="title">{{ $t('navbar_event_dashboard') }}</h3>
                    <h5 class="desc">캠페인별 이벤트 통계 데이터를 확인해보세요.</h5>
                </div>
            </div>
        </div>
        <div class="card-body px-0 pt-0 pb-2 table-with-search" style="margin-bottom: 55px;">

            <div class="event-filter-container">
                <div class="event-filter-left">
                    <div class=event-filter-row>
                        <label class="label">이벤트 캠페인 선택</label>
                        <a-select
                            v-model:value="selectedEventId"
                            class="event-select"
                            style="min-width: 350px;"
                            @change="uiHandler.handleEventChange"
                        >
                        
                            <a-select-option
                                v-for="(item, index) in eventList"
                                :key="item._id"
                                :value="item._id"
                            >
                                {{  }}
                                {{ item.name + '(' + uiHandler.convertDateBySplitting(item.startAt) + ' ~ ' +  uiHandler.convertDateBySplitting(item.endAt) + ')' }}
                            </a-select-option>
                        </a-select>
                    </div>
                    <div class=event-filter-row>
                        <label class="label">조회 기간</label>
                        <a-radio-group v-model:value="events.selectedRound" @change="uiHandler.handleRoundChange">
                            <a-radio :value="-2">전체</a-radio>
                            <a-radio v-for="(round, index) in events.eventRounds" :key="index" :value="index">
                                {{ round.label || `${index + 1}회차` + '(' + uiHandler.convertDateBySplitting(round.startAt) + ' ~ ' + uiHandler.convertDateBySplitting(round.endAt) + ')' }}
                            </a-radio>
                            <!-- <a-radio :value="-1">기간 설정</a-radio> -->
                        </a-radio-group>
                        <!-- <a-range-picker 
                         v-if="events.selectedRound === -1"
                            :allowClear="false" 
                            :locale="locale" 
                            v-model:value="dateRanges" 
                            @change="uiHandler.getEventStats"
                            style="width: 250px; margin-bottom: 10px"
                        /> -->
                        <!-- <a-checkbox 
                            v-model:checked="isAllPeriodChecked"
                            @change="uiHandler.handleIsAllPeriodChecked"
                        >
                            전체 기간 조회
                        </a-checkbox> -->
                    </div>
                </div>
                <div class="event-filter-right" style="display: flex; gap: 16px;">
                    <a-button
                        type="primary"
                        @click="uiHandler.downloadExcel"
                    >
                        <template #icon>
                            <i class="fa-solid fa-down-to-bracket"/>
                        </template>
                        엑셀 다운로드
                    </a-button>
                    <!-- <a-button
                        type="primary"
                        @click="uiHandler.downloadPdf"
                    >
                        <template #icon>
                            <i class="fa-solid fa-file-pdf"/>
                        </template>
                        PDF로 다운로드
                    </a-button> -->
                </div>
            </div>
            <div class="asd" ref="contentToExport">
                <component 
                    :is="getEventComponent" 
                    :event-data="eventInfo"
                    :selected-event-id="selectedEventId"
                    :selected-event-code="selectedEventCode"
                />
            </div>
        </div>
       

        <!-- <pagination
            v-if="!noResult"
            :page-info="paginationData"
            page-name="EventList"
            @change-page="async (childPassParam) => {
                paginationData.currentPage = childPassParam.page;
                await uiHandler.search()
            }"
        /> -->
    </a-col>
    <a-col :span="1"></a-col>
</a-row>
</template>
<script>
import { getProfile } from '@/utils/tokenStore';
import Pagination from "@/views/components/Pagination.vue";
import eventApis from "@/views/EventManagement/api";
import {
  formatCommaNumber,
  oneBtnDialog,
  convertToLocalTime,
} from "@/utils/utils";
import dayjs from "dayjs";
import 'dayjs/locale/ko'
import locale from "ant-design-vue/es/date-picker/locale/ko_KR";
import Summer2024 from "@/views/EventManagement/components/zeiss/Summer2024.vue";
import Survey2024 from "@/views/EventManagement/components/zeiss/Survey2024.vue";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import html2pdf from 'html2pdf.js';
import { RouterEnum } from "@/enums/router.enums";

export default {
  components: {
      Pagination,
      Summer2024,
      Survey2024,
    },
  computed: {
    noResult() {
      return !this.$store.state.isLoading && this.events.totalDocs === 0
    },
    computedNoResultMessage() {
        return this.$i18n.t('noresult_event');
      if(this.calledApiTimes <= 1) {
      } else {
        return this.$i18n.t('noresult_event_period');
      }
    },
    statusList() {
      return [
        {label: '전체', value: '전체'},
        {label: '예정', value: '예정'},
        {label: '진행중', value: '진행중'},
        {label: '종료', value: '종료'},
      ]
    },
    getEventComponent() {
      const eventCode = this.eventList.find(event => event._id === this.selectedEventId)?.eventCode;
      // 선택된 이벤트에 따라 적절한 컴포넌트를 반환
      if (eventCode === '2024SUMMER') {
        return Summer2024;
      }
      if (eventCode === '2024SURVEY') {
        return Survey2024;
      }
      // 다른 이벤트에 대한 컴포넌트 반환 로직
      return null; // 또는 기본 컴포넌트
    },
  },
  data() {
    return {
      uiHandler: this.ui(),
      apiHandler: this.api(),
      formatCommaNumber,
      dateRanges: [dayjs().startOf('month'), dayjs()],
      locale,
      dataLoading: false,
      modal: {
        createEvent: {
            show: false
        },
      },
      calledApiTimes: 0,
      searchFilter: {
        keyword: {
            option: '이벤트명',
            word: ''
        },
        status: '전체',
        selectedDateFilter: 'all',
        dateFilters: [3, 12, 'etc'],
        startContractDate: '',
        endContractDate: '',
        sort: {
            parameter: 'validationDate',
            method: 'descend'
        }
      },
      paginationData: {
            listSize: 0,
            rowsPerPage: 10,
            currentPage: 1,
            totalPages: 1,
      },
      isAllPeriodChecked: false,
      page: 1,
      events: {
        startAt: null,
        endAt: null,
        totalDocs: 0,
        list: [],
        selectedRound: -2,
        eventRounds: [],
      },
      selectedEventCode: undefined,
      selectedEventId: undefined,
      eventList: [],

      eventInfo: {},
    }
  },
  async mounted() {
    await this.uiHandler.getEventList();
    // await this.uiHandler.search();
  },
  methods: {
    dayjs,
    ui() {
      return {
        convertDateBySplitting: (dateString) => {
            if(!dateString || typeof dateString !== 'string') return '';

            // convertToLocalTime 사용하여 UTC를 한국 시간으로 변환
            const localTime = convertToLocalTime(dateString);
            if(localTime === '-') return '';
            
            // YYYY/MM/DD 형식으로 변환
            const dateOnly = localTime.split(' ')[0];
            return dateOnly.replaceAll('/', '/');
        },
        search: async () => {
            // if(dayjs(this.events.startAt) !== dayjs(this.dateRanges[0])) {
            //     this.isAllPeriodChecked = false;
            // }
            // if(dayjs(this.events.endAt) !== dayjs(this.dateRanges[0])) {
            //     this.isAllPeriodChecked = false;
            // }
            await this.uiHandler.getEventList();
            await this.uiHandler.getEventStats();
        },
        handleEventChange: async (eventId) => {
            const selectedEvent = this.eventList.find(event => event._id === eventId);
            let v3EventIds = ['688c74fa9bad033589258352', '6860e05ccca7ad7006779b45', '6864f97c93111a68978dc3f5'];
            
            // 더미 이벤트 처리
            if (eventId === 'dummyEventId3') {
              // 2025 여름 후기 이벤트 - ReviewEventSummary 페이지로 이동
              this.$router.push('/events-v2/review-summary');
              return;
            } else if (eventId === 'dummyEventId' || eventId === 'dummyEventId2') {
              // 다른 더미 이벤트들은 현재 페이지에서 머물기
              return;
            }
            
            if(v3EventIds.includes(eventId)) {
              console.log('here 1')
              this.$router.push({
                  name: RouterEnum.EventManagementV2.EventStatistics.name,
                  query: { eventId: eventId }
              });
              return;
            }
            this.selectedEventId = selectedEvent._id;
            this.selectedEventCode = selectedEvent.eventCode;
            this.events.startAt = selectedEvent.startAt;
            this.events.endAt = selectedEvent.endAt;
            this.events.selectedRound = -2;
            if(selectedEvent.round.length > 0) {
              this.events.eventRounds = selectedEvent.round.map((round, index) => ({
                  ...round,
                  label: round.label || `${index + 1}회차` + '(' + dayjs(round.startAt).format('YYYY/MM/DD') + ' ~ ' + round.endAt.split('T')[0] + ')'
              }));
            } else {
              this.events.eventRounds = [];
            }
            this.uiHandler.updateDateRanges();
            await this.uiHandler.getEventStats();
        },
        downloadExcel: async () => {
          const formattedDate = dayjs().format("YYYYMMDD");

          const obj = {};
          obj.startAt = dayjs(this.dateRanges[0]).add(0, 'hour');
          obj.endAt = dayjs(this.dateRanges[1]).add(0, 'hour');
          obj.eventId = this.selectedEventId;

          try {
            this.$store.commit('setIsLoading', true);

            const response = await this.apiHandler.downloadExcel(obj);

            const blob = new Blob([response.data], {
              type: 'application/octet-stream',
            });

            const url = URL.createObjectURL(blob);

            const downloadLink = document.createElement('a');
            downloadLink.href = url;
            downloadLink.download = `${this.$i18n.t('event_excel_filename')}_${formattedDate}.xlsx`;
            downloadLink.click();

            URL.revokeObjectURL(url);
        
            this.$store.commit('setIsLoading', false);
          } catch (error) {
            this.$store.commit('setIsLoading', false);
            console.error('error: ', error);
            console.log(error.response.data)
            if (error.response && error.response.status === 404) {
                if (error.response.data instanceof Blob) {
                    console.log('here 2')
                    const reader = new FileReader();
                    reader.readAsText(error.response.data);
                    reader.onload = async () => {
                        try {
                            const errorData = JSON.parse(reader.result);
                            await oneBtnDialog(this.$i18n.t('certificatelist_list_empty_title'), errorData.message, false);
                        } catch {
                            await oneBtnDialog(this.$i18n.t('certificatelist_list_empty_title'), this.$i18n.t('certificatelist_list_excel_error'), false);
                        }
                    };
                    reader.onerror = async () => {
                        await oneBtnDialog(this.$i18n.t('certificatelist_list_empty_title'), this.$i18n.t('certificatelist_list_excel_error'), false);
                    };
                } else {
                    console.log('here 3')
                    await oneBtnDialog(this.$i18n.t('certificatelist_list_empty_title'), this.$i18n.t('certificatelist_list_excel_error'), false);
                }
            } else if(error.response && error.response.data?.statusCode === 404) {
                await oneBtnDialog(this.$i18n.t('certificatelist_list_empty_title'), this.$i18n.t('certificatelist_list_excel_error'), false);
            } else {
                console.log('here 4')
                await oneBtnDialog(this.$i18n.t('certificatelist_list_empty_title'), this.$i18n.t('certificatelist_list_excel_error'), false);
            }
          }
        },
        downloadParticipantsExcel: async () => {
          if(this.events.list.length === 0) {
            await oneBtnDialog(this.$i18n.t('certificatelist_list_empty_title'),this.$i18n.t('certificatelist_list_empty_content'), false);
            return;
          }
          
          const formattedDate = dayjs().format("YYYYMMDD");

          const obj = {};
          if(this.events.selectedRound !== -2) {
            obj.startAt = dayjs(this.dateRanges[0]).add(0, 'hour');
            obj.endAt = dayjs(this.dateRanges[1]).add(0, 'hour');
          } else {
            obj.startAt = dayjs(this.events.eventRounds[0].startAt).add(0, 'hour');
            obj.endAt = dayjs(this.events.eventRounds[0].endAt).add(0, 'hour');
          }

            
          obj.eventId = this.selectedEventId;

          try {
            this.$store.commit('setIsLoading', true);

            const response = await this.apiHandler.downloadParticipantsExcel(obj);

            const blob = new Blob([response.data], {
              type: 'application/octet-stream',
            });

            const url = URL.createObjectURL(blob);

            const downloadLink = document.createElement('a');
            downloadLink.href = url;

            const selectedEventName = this.eventList.find(event => event._id === this.selectedEventId)?.name;
            downloadLink.download = `${selectedEventName}_응모자 목록.xlsx`;
            downloadLink.click();

            URL.revokeObjectURL(url);
        
            this.$store.commit('setIsLoading', false);
          } catch (error) {
            this.$store.commit('setIsLoading', false);
            console.error('error: ', error);
            if (error.response && error.response.status === 404) {
                if (error.response.data instanceof Blob) {
                    const reader = new FileReader();
                    reader.readAsText(error.response.data);
                    reader.onload = async () => {
                        try {
                            const errorData = JSON.parse(reader.result);
                            await oneBtnDialog(this.$i18n.t('certificatelist_list_empty_title'), errorData.message, false);
                        } catch {
                            await oneBtnDialog(this.$i18n.t('certificatelist_list_empty_title'), this.$i18n.t('certificatelist_list_excel_error'), false);
                        }
                    };
                    reader.onerror = async () => {
                        await oneBtnDialog(this.$i18n.t('certificatelist_list_empty_title'), this.$i18n.t('certificatelist_list_excel_error'), false);
                    };
                } else {
                    await oneBtnDialog(this.$i18n.t('certificatelist_list_empty_title'), this.$i18n.t('certificatelist_list_excel_error'), false);
                }
            } else {
                await oneBtnDialog(this.$i18n.t('certificatelist_list_empty_title'), this.$i18n.t('certificatelist_list_excel_error'), false);
            }
          }
        },
        downloadPdfV1: async () => {
            this.$store.commit('setIsLoading', true);
            const element = this.$refs.contentToExport;

            // html2pdf 옵션 설정
            const opt = {
            margin:       [10, 10, 10, 10], // [상, 우, 하, 좌] 여백 설정
            filename:     'download.pdf',
            image:        { type: 'png', quality: 0.95 },
            html2canvas:  { scale: 2, useCORS: true },
            jsPDF:        { orientation: 'landscape', unit: 'mm', format: 'a4' },
            pagebreak:    { mode: ['css', 'legacy'] } // CSS 기반 페이지 분할 시도
            };

            // PDF 생성 및 다운로드
            await html2pdf().set(opt).from(element).save();
            this.$store.commit('setIsLoading', false);
        },
        downloadPdf: async () => {
            this.$store.commit('setIsLoading', true);
        
            // PDF로 변환할 요소 선택
            const element = this.$refs.contentToExport;
            
            // html2canvas로 요소 캡처 (해상도 향상을 위해 scale: 2 사용)
            const canvas = await html2canvas(element, { scale: 2 });
            
            // 캔버스를 이미지 데이터로 변환
            const imgData = canvas.toDataURL('image/png', 0.9);
            
            // jsPDF 인스턴스 생성 (A4 사이즈, 가로 방향)
            const pdf = new jsPDF('landscape', 'mm', 'a4');
            const pdfWidth = pdf.internal.pageSize.getWidth(); // 297mm
            const pdfHeight = pdf.internal.pageSize.getHeight(); // 210mm
            const margin = 10; // 10mm 마진
            
            // PDF에 삽입할 이미지의 너비와 높이 계산 (여백 고려)
            const imgWidthPdf = pdfWidth - 2 * margin; // 277mm
            const imgHeightPdf = (canvas.height * imgWidthPdf) / canvas.width; // 비율에 맞춘 높이
            
            // 전체 페이지 수 계산
            const totalPages = Math.ceil(imgHeightPdf / (pdfHeight - 2 * margin));
            console.log(`Total Pages: ${totalPages}`);
            
            // 페이지별로 캔버스를 슬라이스하여 PDF에 추가
            for (let page = 0; page < totalPages; page++) {
                if (page > 0) {
                    pdf.addPage();
                }
                
                // 현재 페이지에서 캔버스의 y축 시작 위치 (픽셀 단위)
                const sliceHeightPx = (pdfHeight - 2 * margin) * (canvas.width / imgWidthPdf);
                const yStart = page * sliceHeightPx;
                const yEnd = yStart + sliceHeightPx > canvas.height ? canvas.height : yStart + sliceHeightPx;
                const sliceHeight = yEnd - yStart;
                
                console.log(`Page ${page + 1}: yStart=${yStart}, sliceHeight=${sliceHeight}`);
                
                // 슬라이스할 부분을 담을 임시 캔버스 생성
                const tempCanvas = document.createElement('canvas');
                tempCanvas.width = canvas.width;
                tempCanvas.height = sliceHeight;
                const tempContext = tempCanvas.getContext('2d');
                
                // 원본 캔버스에서 슬라이스된 부분을 임시 캔버스로 그리기
                tempContext.drawImage(
                    canvas,
                    0,
                    yStart,
                    canvas.width,
                    sliceHeight,
                    0,
                    0,
                    canvas.width,
                    sliceHeight
                );
                
                // 슬라이스된 임시 캔버스를 이미지 데이터로 변환
                const sliceImgData = tempCanvas.toDataURL('image/png', 0.9);
                
                // 슬라이스된 이미지의 PDF 내 높이 계산
                const slicePdfHeight = (sliceHeight * imgWidthPdf) / canvas.width;
                console.log(`Slice PDF Height: ${slicePdfHeight}mm`);
                
                // 슬라이스된 이미지를 PDF에 추가
                pdf.addImage(
                    sliceImgData,
                    'PNG',
                    margin,
                    margin,
                    imgWidthPdf,
                    slicePdfHeight
                );
            }
            
            // PDF 저장
            pdf.save('download.pdf');
            this.$store.commit('setIsLoading', false);

        },
        initEventData: () => {
            this.events.list = [];
        },
        getEventStats: async () => {
            try {
                this.eventInfo = {};
                this.dataLoading = true;
                const obj = {};
                obj.startAt = dayjs(this.dateRanges[0]).add(0, 'hour');
                obj.endAt = dayjs(this.dateRanges[1]).add(0, 'hour');
                obj.eventId = this.selectedEventId;
                const response = await this.apiHandler.getEventStats(obj);
                if(!response.data) throw new Error('data 없음');
                if(!response.data.eventStats) throw new Error('eventStats does not exist');

                this.calledApiTimes ++;
                if(response.data.eventStats.length === 0) {
                    this.uiHandler.initEventData();
                    return;
                }

                this.eventInfo = response.data;
          } catch(error) {
            console.log(error);
            await oneBtnDialog('이벤트 통계 로드 실패', '이벤트 통계 자료 로드에 실패했습니다.');
          } finally {
            this.dataLoading = false;
          }
        },
        updateDateRanges: () => {
            const selectedEvent = this.eventList.find(event => event._id === this.selectedEventId);
            if (!selectedEvent) return;

            if (this.events.selectedRound === -2) {
                // '전체' 선택 시
                this.dateRanges = [dayjs(selectedEvent.startAt), dayjs(selectedEvent.endAt)];
            } else if (this.events.selectedRound === -1) {
                // '기간 설정' 선택 시, 현재 dateRanges 유지
                return;
            } else if (this.events.selectedRound >= 0 && this.events.eventRounds[this.events.selectedRound]) {
                // 특정 회차 선택 시
                const selectedRound = this.events.eventRounds[this.events.selectedRound];
                this.dateRanges = [dayjs(selectedRound.startAt), dayjs(selectedRound.endAt)];
            }
        },
        getEventList: async () => {
            const obj = {};
            obj.page = 1;
            obj.limit = 400;
            try {
                this.dataLoading = true;
                const response = await this.apiHandler.getEventList(obj);
                if(response.data.message) throw new Error(response.data.message);
                if(response.data) this.eventList = response.data.docs;
                this.calledApiTimes ++;
                if(this.eventList.length > 0) {
                    this.selectedEventId = this.eventList[1]._id;
                    this.events.startAt = this.eventList[1].startAt;
                    this.events.endAt = this.eventList[1].endAt;
                    this.events.eventRounds = this.eventList[1].round.map((round, index) => ({
                        ...round,
                        label: round.label || `${index + 1}회차` + '(' + this.uiHandler.convertDateBySplitting(round.startAt) + ' ~ ' + this.uiHandler.convertDateBySplitting(round.endAt) + ')'
                    }));
                    if(!this.selectedEventCode) this.selectedEventCode = this.eventList[0].eventCode;
                    this.uiHandler.handleRoundChange();
                    // this.dateRanges[0] = dayjs(this.eventList[0].startAt);
                    // if(dayjs() < dayjs(this.eventList[0].endAt)) {
                    //     this.dateRanges[1] = dayjs();
                    // } else {
                    //     this.dateRanges[1] = dayjs(this.eventList[0].endAt);
                    // }
                }
                
              let defaultEventId;
              if(process.env.NODE_ENV === 'local' || process.env.NODE_ENV === 'development') {
                  defaultEventId = '688c74fa9bad033589258352'; // 개발
              } else if (process.env.NODE_ENV === 'stage') {
                  defaultEventId = '6860e05ccca7ad7006779b45'; // 스테이징
              } else {
                  defaultEventId = '6864f97c93111a68978dc3f5'; // 운영
              }
              // 이벤트 통계 메뉴인 경우 더미 이벤트들 추가
              if (getProfile('manufacturerNameManu') == '자이스코리아') {
                 
                  this.eventList.push({
                    _id: 'dummyEventId3',
                    name: '2025 여름 후기 이벤트',
                    startAt: '2025-06-20',
                    endAt: '2025-08-31',
                    round: []
                  });
                  this.eventList.push({
                    _id: defaultEventId,
                    name: '스마일 카드 공유 이벤트',
                    startAt: '2025-07-03',
                    endAt: '2025-08-31',
                    round: []
                  });
              }
            } catch (error) {
                console.log(error);
                await oneBtnDialog('이벤트 목록 로드 실패', '이벤트 목록 로드에 실패했습니다.');
            } finally {
                this.dataLoading = false;
            }
        },
        handleRoundChange: () => {
            this.uiHandler.updateDateRanges();
            this.uiHandler.getEventStats();
        },
        convertMonthAndYearText: (input) => {
          if (input < 12) return `${input}${this.$i18n.t('common_searchfilter_month')}`;
          return `${input / 12}${this.$i18n.t('common_searchfilter_year')}`;
        },
      }
    },
    api() {
      return eventApis(this.$apiInstance, this.$store);
    }
  }
}
</script>
<style lang="scss">
  @import './event.scss';
</style>
<style scoped lang="scss">
.search-filter-content {
  .mobile-wrap {
    display: flex;
    gap: 8px;
  }

  .mobile-no-wrap {
    display: flex;
  }
}

@media screen and (max-width: 767px) {
  .date-selector-container,
  .ant-picker.ant-picker-range {
    width: 100% !important;
  }
  .search-filter-content .date-filter-container-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;

    .date-filter-container {
      flex-direction: row;
      border-radius: 0;
      border-bottom: 0;

      .date-filter-item {
        width: 50%;
        border-bottom: 0;
      }
    }
  }
  .container-fluid .row.justify-content-center {
    padding: 14px 14px 36px 14px !important;
  }
  .mainDiv {
    width: 100% !important;
  }
  .search-filter-title {
    margin-right: auto;
    width: auto;
    margin-left: 10px;
  }
  .search-filter-content .mobile-wrap {
    width: 100%;
  }
  .search-filter-content .search-select {
    width: 100px;
  }
  .search-filter-content .search-input-container {
    width: calc(100% - 100px);
    display: flex;
    justify-content: flex-start;

    input {
      width: 100%;
    }
  }
  .search-filter-content .date-filter-container {
    height: auto;
  }
  .search-filter-content .date-selector-container.custom {
    flex-direction: column;
    height: auto;
    align-items: center;
  }
  .search-filter-content .date-filter-container {
    flex-direction: column;
  }
  .search-filter-row {
    height: auto;
  }
  .search-filter-row,
  .search-filter-content {
    flex-direction: column;
    flex: none;
  }
  .card-header {
    margin: 0;
  }
}

@media screen and (min-width: 768px) and (max-width: 1023px) {
  .search-filter-title {
    width: 100%;
    justify-content: flex-start;
    margin-left: 20px;
  }
  .table-with-search .table-info-filter {
    flex-direction: column;
    width: 100%;

    .total-div {
      margin-right: auto;
    }

    .search-container {
      width: 100%;
      flex-direction: row;

      .search-select {
        margin-right: auto;
      }

      .search-div {
        flex-direction: row;
        width: 100%;

        input {
          width: calc(100% - 80px) !important;
        }

        .search-btn {
          min-width: 80px;
        }
      }
    }
  }
  .search-filter-row {
    flex-direction: column;
    height: auto;

    &:nth-of-type(2) {
      .search-filter-content {
        flex-direction: column;
      }

      .search-filter-content {
        align-items: flex-start;
      }

      .date-selector-container.custom {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
      }
    }
  }
}
</style>